module.exports = __webpack_public_path__ + "static/img/cert2.8ad6fa1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutpic/cert2.png
// module id = +luM
// module chunks = 51